import { useApp } from '../../hook/app.hook';
import { useUser } from '../../hook/user.hook';
import { TestPattern } from '../../response/test.response';
import { useWindow } from '../../util/window-helper';
import TestJeeDPage from './test-jee.d';
import TestJeeMPage from './test-jee.m';
import TestDPage from './test.d';
import TestMPage from './test.m';
import { useEffect } from 'react';

const TestPage = () => {
  const { isMobile } = useWindow();

  const { fetchUser } = useUser();
  const { testRes } = useApp();

  useEffect(() => {
    fetchUser();
  }, []);

  const isNTAPattern =
    testRes.pattern == TestPattern.JEE_MAIN ||
    testRes.pattern == TestPattern.NEET ||
    testRes.pattern == TestPattern.JEE_ADVANCE ||
    testRes.pattern == TestPattern.NTA ||
    testRes.pattern == TestPattern.CHAPTER_TEST ||
    testRes.pattern == TestPattern.MHCET_MATH ||
    testRes.pattern == TestPattern.MHCET_BIOLOGY;

  return (
    <>
      {isNTAPattern ? (
        <>{isMobile ? <TestJeeMPage /> : <TestJeeDPage />}</>
      ) : (
        <>{isMobile ? <TestMPage /> : <TestDPage />}</>
      )}
    </>
  );
};

export default TestPage;
